<template>
  <DialogTutorialBase :delay-button="600" v-bind="props">
    <template #title> Allez, bisous 🚀 </template>
    <DomFade :delay="10">
      On sait que tu vas <strong>tout donner</strong>…
    </DomFade>
    <DomFade :delay="120"> <strong>Bonnes révisions</strong> ! </DomFade>
  </DialogTutorialBase>
</template>
<script lang="ts" setup>
interface Props {
  onNext: Function;
}
const props = defineProps({
  onNext: { type: Function }
});
</script>
<style lang="scss" scoped>
ul.stores {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  li {
    width: 100px;
  }
}
</style>
